import React from 'react';
import DatePicker from "react-datepicker";
import moment from 'moment';

const SalaryStatementsHeader = ({
    selectedFirm,
    onFirmChange,
    firmOptions = [],
    firmOptionsLoading = false,
    startDate,
    endDate,
    onDateRangeChange,
    filterDate
}) => {
    const handleDateRangeChange = (dates) => {
        if (onDateRangeChange) {
            onDateRangeChange(dates);
        }
    };

    // Custom input component to display the date range
    const CustomInput = React.forwardRef(({ value, onClick }, ref) => {
        // Format the display value
        let displayValue = value || 'Select date range';
        if (startDate && endDate) {
            displayValue = `${moment(startDate).format('DD.MM.YYYY')} - ${moment(endDate).format('DD.MM.YYYY')}`;
        } else if (startDate) {
            displayValue = `${moment(startDate).format('DD.MM.YYYY')} - ...`;
        }
        
        return (
            <input
                type="text"
                value={displayValue}
                onClick={onClick}
                ref={ref}
                readOnly
                className="date-picker-input"
                placeholder="Select date range"
            />
        );
    });
    CustomInput.displayName = 'CustomInput';

    try {
        // Don't check for selectedFirm here - parent component handles loading/auto-selection
        return (
        <div className="salary-statements-header">
            {/* Date range and summary */}
            <div className="header-row-2">

                <div className="date-range-picker">
                    <DatePicker
                        selected={startDate}
                        onChange={handleDateRangeChange}
                        startDate={startDate}
                        endDate={endDate}
                        selectsRange
                        dateFormat="dd.MM.yyyy"
                        customInput={<CustomInput />}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        isClearable={false}
                        autoComplete="off"
                        filterDate={filterDate}
                        popperProps={{
                            strategy: "fixed",
                            modifiers: [
                                {
                                    name: "preventOverflow",
                                    options: {
                                        boundary: "viewport"
                                    }
                                }
                            ]
                        }}
                        portalId="root"
                    />
                </div>
                    
                <div className="firm-selector">
                    <select 
                        id="firm-select"
                        value={selectedFirm || ''} 
                        onChange={(e) => onFirmChange && onFirmChange(e.target.value)}
                        disabled={firmOptionsLoading}
                        className="firm-select-input"
                    >
                        <option value="">Select a firm...</option>
                        {firmOptions && Array.isArray(firmOptions) && firmOptions.map(firm => (
                            <option key={firm.id} value={firm.id}>
                                {firm.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
    } catch (error) {
        console.error('Error in SalaryStatementsHeader:', error);
        return (
            <div className="error-container">
                <p>Error loading salary statements header. Please refresh the page.</p>
            </div>
        );
    }
};

export default SalaryStatementsHeader;
